import React from 'react';
import { Box, Typography, Paper, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { AddAPhoto, CheckCircleOutline } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import DynamicMerchantTabs from '../Layout/DynamicMerchantTabs';

const PURPLE = '#6318C6';
const PURPLE_LIGHT = '#f3eeff';

const capabilities = [
  'Upload a real customer or model photo to use as the face in your AI generations',
  'Generate personalised jewellery shots with a specific person\'s face',
  'Create try-on previews for customers using their own uploaded photo',
  'Switch between AI models and customer photo in the generation wizard',
];

export default function CustomerPhotoPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f8f9fa' }}>
      <DynamicMerchantTabs />
      <Box sx={{ flex: 1, p: { xs: 2, md: 4 }, maxWidth: 720, mx: 'auto', width: '100%' }}>
        <Paper sx={{ p: 4, borderRadius: 3, border: '1px solid #e5e7eb' }}>
          <Box display="flex" alignItems="center" gap={2} mb={3}>
            <Box sx={{ width: 56, height: 56, borderRadius: 2, bgcolor: PURPLE_LIGHT, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <AddAPhoto sx={{ color: PURPLE, fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={700}>Customer Photo</Typography>
              <Typography variant="body2" color="text.secondary">Personalised AI generations with real faces</Typography>
            </Box>
          </Box>

          <Typography color="text.secondary" mb={3}>
            Upload a customer or model photo and use it as the face in your AI-generated jewellery shots.
            Create highly personalised product images and try-on previews that resonate with your buyers.
          </Typography>

          <Typography variant="subtitle2" fontWeight={700} mb={1.5}>What you can do</Typography>
          <List disablePadding sx={{ mb: 3 }}>
            {capabilities.map((cap) => (
              <ListItem key={cap} disableGutters sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <CheckCircleOutline sx={{ color: PURPLE, fontSize: 18 }} />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">{cap}</Typography>} />
              </ListItem>
            ))}
          </List>

          <Button
            variant="contained"
            onClick={() => navigate('/generate')}
            sx={{ bgcolor: PURPLE, '&:hover': { bgcolor: '#5214a6' }, borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
            Start Generating
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
